import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from '@/contexts/AuthContext';
import { BlueMonkProvider } from '@/contexts/BlueMonkContext';
import { TaskProvider } from '@/contexts/TaskContext';
import ProtectedRoute from '@/components/ProtectedRoute';
import Login from '@/pages/Login';
import Dashboard from '@/pages/Dashboard';
import RASheet from '@/pages/RASheet';
import TeamTasks from '@/pages/TeamTasks';
import PriorityTasks from '@/pages/PriorityTasks';
import Accounts from '@/pages/Accounts';
import AccountDetail from '@/pages/AccountDetail';
import TeamManagement from '@/pages/TeamManagement';
import Reports from '@/pages/Reports';
import HolidayCalendar from '@/pages/HolidayCalendar';
import WorkCards from '@/pages/WorkCards';
import ImportantInformation from '@/pages/ImportantInformation';
import ClientReport from '@/pages/ClientReport';
import ClientDeliverables from '@/pages/ClientDeliverables';
import ContentCalendar from '@/pages/ContentCalendar';
import Layout from '@/components/layouts/Layout';
import { Toaster } from '@/components/ui/sonner';

// BlueMonk Portal Pages
import BlueMonkPinEntry from '@/pages/bluemonk/PinEntry';
import BlueMonkPortal from '@/pages/bluemonk/Portal';
import BlueMonkAdminLogin from '@/pages/bluemonk/AdminLogin';
import BlueMonkAdminDashboard from '@/pages/bluemonk/AdminDashboard';

function App() {
  return (
    <AuthProvider>
      <BlueMonkProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              {/* Public Routes */}
              <Route path="/login" element={<Login />} />
              <Route path="/report/:accountId" element={<ClientReport />} />
              
              {/* BlueMonk Client Portal Routes */}
              <Route path="/bluemonk" element={<BlueMonkPinEntry />} />
              <Route path="/bluemonk/portal" element={<BlueMonkPortal />} />
              
              {/* BlueMonk Admin Routes */}
              <Route path="/bluemonk/admin" element={<BlueMonkAdminLogin />} />
              <Route path="/bluemonk/admin/dashboard" element={<BlueMonkAdminDashboard />} />
              
              {/* Protected Routes */}
              <Route path="/" element={<ProtectedRoute><TaskProvider><Layout /></TaskProvider></ProtectedRoute>}>
                <Route index element={<Navigate to="/dashboard" replace />} />
                
                {/* Admin Only Routes */}
                <Route path="dashboard" element={<ProtectedRoute adminOnly><Dashboard /></ProtectedRoute>} />
                <Route path="accounts" element={<ProtectedRoute adminOnly><Accounts /></ProtectedRoute>} />
                <Route path="accounts/:accountId" element={<ProtectedRoute adminOnly><AccountDetail /></ProtectedRoute>} />
                <Route path="ra-sheet" element={<ProtectedRoute adminOnly><RASheet /></ProtectedRoute>} />
                <Route path="priority-tasks" element={<ProtectedRoute adminOnly><PriorityTasks /></ProtectedRoute>} />
                <Route path="team-management" element={<ProtectedRoute adminOnly><TeamManagement /></ProtectedRoute>} />
                <Route path="reports" element={<ProtectedRoute adminOnly><Reports /></ProtectedRoute>} />
                <Route path="client-deliverables" element={<ProtectedRoute adminOnly><ClientDeliverables /></ProtectedRoute>} />
                <Route path="content-calendar" element={<ProtectedRoute adminOnly><ContentCalendar /></ProtectedRoute>} />
                
                {/* Team Member Routes - accessible by both admins and members */}
                <Route path="team/:memberId" element={<ProtectedRoute><TeamTasks /></ProtectedRoute>} />
                <Route path="holiday-calendar" element={<ProtectedRoute><HolidayCalendar /></ProtectedRoute>} />
                <Route path="work-cards" element={<ProtectedRoute><WorkCards /></ProtectedRoute>} />
                <Route path="important-information" element={<ProtectedRoute><ImportantInformation /></ProtectedRoute>} />
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" />
        </div>
      </BlueMonkProvider>
    </AuthProvider>
  );
}

export default App;
